import { Icon } from '@acpaas-ui/react-components';
import React from 'react';

const NotFound = () => (
  <div className="u-text-center u-margin-top-lg u-text-danger">
    <h1>
      <Icon name="ai-alert-triangle" />
    </h1>
    <h1 className="u-margin-top">404 - Niet gevonden</h1>
  </div>
);

export default NotFound;
